module.exports = __webpack_public_path__ + "img/profile-check.e6fca3d7.svg";